import { adminHttp } from './adminHttp'

/** 보안 설정·로그 API */
export const adminSecurityApi = {
  metrics: () =>
    adminHttp.get(
      '/admin/security/metrics',
      b => b.data,
      '보안 지표 조회 실패'
    ),

  rules: () =>
    adminHttp.get(
      '/admin/security/rules',
      b => b.data ?? [],
      '보안 규칙 조회 실패'
    ),

  toggleRule: (ruleId: string, enabled: boolean) =>
    adminHttp.patch(
      `/admin/security/rules/${encodeURIComponent(ruleId)}`,
      { enabled },
      b => b.data,
      '보안 규칙 변경 실패'
    ),

  deleteRule: (ruleId: string) =>
    adminHttp.delete(
      `/admin/security/rules/${encodeURIComponent(ruleId)}`,
      () => undefined,
      '보안 규칙 삭제 실패'
    ),

  createRule: (rule: unknown) =>
    adminHttp.post(
      '/admin/security/rules',
      rule,
      b => b.data,
      '보안 규칙 생성 실패'
    ),

  updateRule: (ruleId: string, rule: unknown) =>
    adminHttp.put(
      `/admin/security/rules/${encodeURIComponent(ruleId)}`,
      rule,
      b => b.data,
      '보안 규칙 수정 실패'
    ),

  scan: () =>
    adminHttp.post('/admin/security/scan', {}, b => b.data, '보안 검사 실패'),

  logs: (params: Record<string, unknown>) =>
    adminHttp.get(
      '/admin/security/logs',
      b => b.data,
      '보안 로그 조회 실패',
      params
    ),

  logStats: () =>
    adminHttp.get(
      '/admin/security/logs/stats',
      b => b.data,
      '로그 통계 조회 실패'
    ),
}

export default adminSecurityApi
